import { render, staticRenderFns } from "./InfopointLayoutPreview.vue?vue&type=template&id=71f11b22&scoped=true"
import script from "./InfopointLayoutPreview.vue?vue&type=script&lang=js"
export * from "./InfopointLayoutPreview.vue?vue&type=script&lang=js"
import style0 from "./InfopointLayoutPreview.vue?vue&type=style&index=0&id=71f11b22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f11b22",
  null
  
)

export default component.exports